import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Filter, FilterData, FILTERS } from './filter';

@Pipe({
  name: 'filterLabel',
})
export class FilterLabelPipe implements PipeTransform {
  constructor(@Inject(FILTERS) public readonly filters: Filter[]) {}

  transform({ filter, value, operation }: FilterData): string {
    const selectedOperation = filter.operations.find(
      (prop) => prop.value === operation
    );
    if (!selectedOperation) {
      throw new Error(`Unknown ${operation} operation`);
    }
    return `${filter.label} ${selectedOperation.label.toLowerCase()} ${value}`;
  }
}
